'use client';
import moment from 'moment';
import {useTranslations} from 'next-intl';

export default function DateBlock({
  date,
  format
}: {
  date: Date;
  format?: string;
}) {
  const w = useTranslations('Date');
  const weekday = {
    Monday: w('Monday'),
    Tuesday: w('Tuesday'),
    Wednesday: w('Wednesday'),
    Thursday: w('Thursday'),
    Friday: w('Friday'),
    Saturday: w('Saturday'),
    Sunday: w('Sunday')
  };

  const formatDate = (dateStr: Date, format: string = 'dateFormat') => {
    const date = moment(dateStr);

    if (['dateFormat', 'dateFormatLong'].includes(format)) {
      return date
        .format(w(format as 'dateFormat' | 'dateFormatLong'))
        .replace(
          date.format('dddd'),
          weekday[date.format('dddd') as keyof typeof weekday]
        );
    }
  };

  return <>{formatDate(date, format)}</>;
}
